import { ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router';

export default function ModalBackButton() {
  const navigate = useNavigate();

  return (
    <ActionIcon color={'black'} variant="subtle" onClick={() => navigate(-1)}>
      <IconArrowLeft />
    </ActionIcon>
  );
}
